import React from 'react'
import Svg, { ClipPath, Defs, G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconBuilding = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconBuilding.dimensions.width} ${IconBuilding.dimensions.height}`}
      {...otherProps}
    >
      <G fill={color || Color.premiumBlack} clipPath="url(#a)">
        <Path d="M13.905 17.866H3.98V1.3h9.924v16.567Zm-9.25-.707h8.572V2.007H4.655V17.16Z" />
        <Path d="M4.572 17.867H0V8.808c0-1.443 1.124-2.613 2.502-2.613h2.07v11.672Zm-3.898-.708h3.224V6.899H2.505c-1.006 0-1.828.857-1.828 1.91v8.35H.674ZM18 17.867h-4.776V6.195h2.274C16.88 6.195 18 7.369 18 8.808v9.059Zm-4.103-.708h3.426v-8.35c0-1.053-.822-1.91-1.829-1.91h-1.597v10.26ZM12.372 2.007h-6.85V.133h6.85v1.874ZM6.195 1.3h5.5V.84h-5.5v.46ZM8.3 6.257H5.904V3.76H8.3v2.498ZM6.578 5.55h1.045V4.462H6.578V5.55Zm5.412.707H9.595V3.76h2.395v2.498Zm-1.722-.707h1.045V4.462h-1.045V5.55ZM8.3 9.698H5.904V7.199H8.3v2.499ZM6.578 8.99h1.045V7.903H6.578V8.99Zm5.412.708H9.595V7.199h2.395v2.499Zm-1.722-.708h1.045V7.903h-1.045V8.99ZM11.131 17.867H6.768V11.42h4.363v6.448Zm-3.69-.707h3.013v-5.037H7.44v5.037Z" />
        <Path d="M9.284 11.861h-.678v5.654h.678v-5.654Z" />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" d="M0 .133h18v17.733H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

IconBuilding.dimensions = {
  width: 24,
  height: 24,
}

export default IconBuilding
